/**
 * Created by scuzzort3 on 7/31/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('HierarchyController', HierarchyController);

    HierarchyController.$inject = ['$modal'];

    function HierarchyController($modal) {
        var vm = this;
        vm.onCommunityClicked = onCommunityClicked;
        vm.onAddChildClicked = onAddChildClicked;
        vm.communitySearchText = "";
        vm.refreshCommunityList = false;
        vm.showHierarchy = false;

        function onCommunityClicked(communityNode) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/hierarchy/addOrEditChildModal.template.html',
                controller: 'EditChildModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    communityNode: function () {
                        return communityNode;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.refreshCommunityList = true;
            });
        }

        function onAddChildClicked(communityNode) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/hierarchy/addOrEditChildModal.template.html',
                controller: 'EditChildModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    communityNode: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.refreshCommunityList = true;
            });
        }
    }
})();